import script from "./Spin.vue?vue&type=script&setup=true&lang=ts"
export * from "./Spin.vue?vue&type=script&setup=true&lang=ts"

import "./Spin.vue?vue&type=style&index=0&id=2edc762e&scoped=true&lang=scss"

import exportComponent from "/var/www/fgc-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2edc762e"]])

export default __exports__